export default [{
  value: 'compassion_group',
  label: 'Compassion Group'
},
{
  value: 'care_coordinator',
  label: 'Care Coordinator'
},
{
  value: 'client_services',
  label: 'Client Services'
},
{
  value: 'enrollment',
  label: 'Enrollment'
},
{
  value: 'lcsw',
  label: 'LCSW'
},
{
  value: 'lhcm',
  label: 'LHCM'
},
{
  value: 'nurse',
  label: 'Nurse'
},
{
  value: 'support_specialist',
  label: 'Support Specialist'
},
{
  value: 'maternity',
  label: 'Maternity'
},
{
  value: 'lucent_rx',
  label: 'LucentRx'
}
]
